/** Copyright 2024 SAP SE or an SAP affiliate company. All rights reserved. */
import React, { useState } from 'react';
import { ThemingParameters } from '@ui5/webcomponents-react-base/dist';
import { BusyIndicator, CommonProps, Text, Title } from '@ui5/webcomponents-react';
import { useTranslations } from '@/hooks/useTranslations';

interface IProps extends CommonProps {
    src: string;
    title?: string;
    description?: string;
    videoW?: string;
    videoH?: string;
}

const VideoIframe: React.FC<IProps> = ({ src, description, title, videoW = '100%', videoH = '100%', style }) => {
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const { t } = useTranslations();
    return (
        <div
            style={{
                background: 'white',
                borderRadius: ThemingParameters.sapContent_Margin_Small,
                height: '100%',
                boxShadow: ThemingParameters.sapContent_Shadow0,
                ...style,
            }}
        >
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%',
                }}
            >
                <div
                    style={{
                        height: '100%',
                        width: '100%',
                        backgroundColor: ThemingParameters.sapBackgroundColor,
                        position: 'relative',
                    }}
                >
                    {isLoading && (
                        <div
                            style={{
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                            }}
                        >
                            <BusyIndicator active size="M" />
                        </div>
                    )}

                    <iframe
                        title="Help Video"
                        src={src}
                        width={videoW}
                        height={videoH}
                        allowFullScreen
                        sandbox="allow-scripts allow-same-origin allow-presentation"
                        onLoad={() => {
                            setIsLoading(false);
                        }}
                    />
                </div>
                <div
                    style={{
                        textAlign: 'center',
                        padding: title && description ? '1rem' : '',
                    }}
                >
                    {title && (
                        <Title
                            style={{
                                fontSize: ThemingParameters.sapFontHeader2Size,
                                padding: ThemingParameters.sapContent_Margin_Small,
                            }}
                        >
                            {t(title)}
                        </Title>
                    )}
                    {description && <Text style={{ textAlign: 'center' }}>{t(description)}</Text>}
                </div>
            </div>
        </div>
    );
};

export default VideoIframe;
